const secrets = {
    third_party_token_set: {
        token_not_found: 'Token kaydı bulunamadı.',
        access_token_expired: "Erişim token'ının süresi doldu. Lütfen hesabınızı yeniden bağlayın.",
    },
};
export default Object.freeze(secrets);
